"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagGroupContextValues_unstable", {
    enumerable: true,
    get: function() {
        return useTagGroupContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function useTagGroupContextValues_unstable(state) {
    const { handleTagDismiss, size } = state;
    return {
        tagGroup: _react.useMemo(()=>({
                handleTagDismiss,
                size
            }), [
            handleTagDismiss,
            size
        ])
    };
}
